export enum EduTradingNewsCategoryType {

    TechnicalAnalysis = "technicalAnalysis",
    MarketNews = "marketNews",
}
